export enum OwnershipTypeEnum {
    Owned = 1,
    NotOwned = 2,
    SecondHand = 3
}
